/**
 * Provides the project codebook to the deeply-nested, recursive step editors
 * without prop-drilling through StepList/StepRow.
 *
 * `TransformView` supplies both the flattened field-path options (for the CALC
 * wizard's field picker) and the raw codebook (so the CAT step can read a
 * dropped container's existing BOOL children to auto-populate its categories).
 * Defaults are empty so consumers render gracefully before the codebook loads.
 */
import { createContext, useContext } from "react"
import { SelectOption } from "types/ui.types"
import { CodebookData } from "types/codebook.types"

export interface CodebookContextValue {
  fields: SelectOption[]
  codebook?: CodebookData
}

export const CodebookFieldsContext = createContext<CodebookContextValue>({
  fields: [],
})

/** Flattened `{ value, label }` field paths — used by the CALC field picker. */
export const useCodebookFields = (): SelectOption[] =>
  useContext(CodebookFieldsContext).fields

/** The raw codebook tree — used to read a container's BOOL children. */
export const useCodebook = (): CodebookData | undefined =>
  useContext(CodebookFieldsContext).codebook
